import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const APEX_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "FMLA Form",
    documentLabel: "{{ dateReceived }} FMLA Form {{ signatureRequired }}",
    folder: "Misc",
    folderMapping: "Misc",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "apex",
  },
  [Classification.ADMIN_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Admin Document",
    documentLabel: "{{ dateReceived }} Admin Document {{ signatureRequired }}",
    folder: "Misc",
    folderMapping: "Misc",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_OTHER,
    group: "apex",
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Clearance Request",
    documentLabel: "{{ dateReceived }} Clearance Request {{ signatureRequired }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "apex",
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "DME",
    documentLabel: "{{ dateReceived }} DME {{ signatureRequired }}",
    folder: "Orders & Rx",
    folderMapping: "Orders & Rx",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "apex",
  },
  [Classification.FINANCIAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Financial Document",
    documentLabel: "{{ dateReceived }} Financial Document",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.FINANCIAL,
    group: "apex",
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Identification Card",
    documentLabel: "{{ dateReceived }} Identification Card",
    folder: "Patient ID Card",
    folderMapping: "Patient ID Card",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "apex",
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "CT",
    documentLabel: "{{ dateOfEvent }} CT {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Radiology",
    folderMapping: "Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "apex",
  },
  [Classification.IMAGING_RESULTS_EMG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "EMG",
    documentLabel: "{{ dateOfEvent }} {{ bodyPartLaterality }}{{ bodyPart }} EMG",
    folder: "Radiology",
    folderMapping: "Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EMG,
    group: "apex",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "MRI",
    documentLabel: "{{ dateOfEvent }} MRI {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Radiology",
    folderMapping: "Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "apex",
  },
  [Classification.IMAGING_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Imaging Result",
    documentLabel: "{{ dateOfEvent }} {{ bodyPartLaterality }}{{ bodyPart }} Imaging Result",
    folder: "Radiology",
    folderMapping: "Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_OTHER,
    group: "apex",
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Ultrasound",
    documentLabel: "{{ dateOfEvent }} Ultrasound {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Radiology",
    folderMapping: "Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "apex",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Insurance Card",
    documentLabel: "{{ dateReceived }} Insurance Card",
    folder: "Patient ID Card",
    folderMapping: "Patient ID Card",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "apex",
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Intake",
    documentLabel: "{{ dateReceived }} Intake",
    folder: "Clinical Forms",
    folderMapping: "Clinical Forms",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "apex",
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Junk",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "apex",
  },
  [Classification.JUNK_FAILED_FAX]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Failed Fax",
    documentLabel: "{{ dateReceived }} Failed Fax",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.JUNK_FAILED_FAX,
    group: "apex",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Lab Results",
    documentLabel: "{{ dateOfEvent }} {{ nameOfLab }} Results {{ significantFindings }}",
    folder: "Labs",
    folderMapping: "Labs",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "apex",
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Legal Document",
    documentLabel: "{{ dateReceived }} Legal Document",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.LEGAL,
    group: "apex",
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medical History Records",
    documentLabel: "{{ dateReceived }} {{ clinicName }} Records",
    folder: "Past Medical History",
    folderMapping: "Past Medical History",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY,
    group: "apex",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medical Record Request",
    documentLabel: "{{ dateReceived }} Med Records Req {{ signatureRequired }}",
    folder: "Medical Records",
    folderMapping: "Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "apex",
  },
  [Classification.MEDICAL_RECORD_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Response to Medical Records Request",
    documentLabel: "{{ dateReceived }} {{ companyName }} Response to Medical Records Request",
    folder: "Medical Records",
    folderMapping: "Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST_RESPONSE,
    group: "apex",
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Other",
    documentLabel: "{{ dateReceived }} Other",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.OTHER,
    group: "apex",
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Rx Related Document",
    documentLabel: "{{ dateReceived }} {{ medications }} Rx Related {{ signatureRequired }}",
    folder: "Prescriptions & Renewals",
    folderMapping: "Prescriptions & Renewals",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "apex",
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Prior Authorization",
    documentLabel: "{{ dateReceived }} Prior Authorization",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "apex",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medication PA Request",
    documentLabel: "{{ dateReceived }} {{ medications }} PA Request",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "apex",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medication PA Response",
    documentLabel: "{{ dateReceived }} {{ medications }} PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "apex",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Procedure PA Request",
    documentLabel: "{{ dateReceived }} {{ documentType }} PA Request",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "apex",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Procedure PA Response",
    documentLabel: "{{ dateReceived }} {{ documentType }} PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "apex",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Progress Note",
    documentLabel: "{{ dateOfEvent }} {{ companyName }} Progress Note",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "apex",
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Op Report",
    documentLabel: "{{ dateOfEvent }} {{ companyName }} Op Report",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "apex",
  },
  [Classification.PROGRESS_NOTE_PRE_OPERATIVE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Pre-Op Note",
    documentLabel: "{{ dateOfEvent }} {{ companyName }} Pre-Op Note",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_PRE_OPERATIVE,
    group: "apex",
  },
  [Classification.PROGRESS_NOTE_PT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "PT Progress Note",
    documentLabel: "{{ dateOfEvent }} {{ companyName }} PT Progress Note",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_PT,
    group: "apex",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: New referral - {{ bodyPartLaterality }}{{ bodyPart }}",
      "Task Note: {{ referringProvider }} referral for {{ reasonForReferral }}; no imaging mentioned. Schedule accordingly",
    ],
    assignedTo: "New Referrals",
    displayName: "Referral",
    documentLabel: "{{ dateReceived }} Referral",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.REFERRAL,
    group: "apex",
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Response to Referral",
    documentLabel: "{{ dateReceived }} {{ clinicName }} Response to Referral",
    folder: "Misc",
    folderMapping: "Misc",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "apex",
  },
  [Classification.REFERRAL_STATUS_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Referral status request",
      "Task Note: {{ referringProvider }} requesting appointment details",
    ],
    assignedTo: "New Referrals",
    displayName: "Referral Status Request",
    documentLabel: "{{ dateReceived }} Referral Status Request",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    priority: "Normal",
    classification: Classification.REFERRAL_STATUS_REQUEST,
    group: "apex",
  },
  [Classification.VITAL_CHART]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Vital Chart Records",
    documentLabel: "{{ dateReceived }} Vital Chart Records",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.VITAL_CHART,
    group: "apex",
  },
} as const;
